import { defineComponent } from "vue";
export default defineComponent({
  name: "App",
  setup() {
    // themeVars 内的值会被转换成对应 CSS 变量
    // 比如 sliderBarHeight 会转换成 `--van-slider-bar-height`
    const themeVars = {
      tagPrimaryColor: "rgba(39, 118, 255, 0.1)",
      tagWarningColor: "rgba(255, 151, 106, 0.1)",
      tagDangerColor: "rgba(238, 10, 36, 0.1)",
      tagSuccessColor: "rgba(7, 193, 96, 0.1)"
    };
    return {
      themeVars
    };
  }
});